import { render, staticRenderFns } from "./Business.vue?vue&type=template&id=3bcf1388"
import script from "./Business.vue?vue&type=script&lang=ts"
export * from "./Business.vue?vue&type=script&lang=ts"
import style0 from "./Business.vue?vue&type=style&index=0&id=3bcf1388&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports